// extracted by mini-css-extract-plugin
export default {"root":"BomLinesOverview_root__WimET","product":"BomLinesOverview_product__cL8dV"};